import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './info-icon-2.css';

const InfoIcon2 = ({ modifier, blue }) => (
    <span
        className={`${
            styles.wrapper} ${
            blue ? styles['wrapper--blue'] : ''} ${
            modifier || ''}`}
    >
        &#9432;
    </span>
);

InfoIcon2.propTypes = {
    blue: PropTypes.bool,
    modifier: PropTypes.string
};

export default InfoIcon2;
